import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Users } from "lucide-react";

export default function Team() {
  const { user } = useAuth();
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.employee_id) {
      setLoading(false);
      return;
    }
    api
      .get(`/employees/${user.employee_id}/team`)
      .then((r) => setTeam(r.data.items || []))
      .finally(() => setLoading(false));
  }, [user?.employee_id]);

  return (
    <div className="max-w-6xl space-y-6" data-testid="team-page">
      <div>
        <div className="axia-overline">Your team</div>
        <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight text-slate-900 mt-1.5">My Team</h1>
        <p className="text-sm text-slate-500 mt-2 max-w-xl">Direct reports who report into you. Click a card to open their profile.</p>
      </div>

      {!user?.employee_id ? (
        <div className="axia-card p-8 text-sm text-slate-500">Your account isn't linked to an employee record yet.</div>
      ) : loading ? (
        <div className="text-sm text-slate-500">Loading…</div>
      ) : team.length === 0 ? (
        <div className="axia-card p-12 text-center text-slate-500">
          <Users className="w-6 h-6 mx-auto text-slate-300" />
          <div className="font-display text-lg font-semibold text-slate-900 mt-3">No direct reports</div>
          <p className="text-sm mt-1">When employees report into you, they'll appear here.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {team.map((m) => (
            <Link
              key={m.id}
              to={`/profile/${m.id}`}
              className="axia-card p-4 hover:border-slate-400 transition"
              data-testid={`team-card-${m.id}`}
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-slate-900 text-white flex items-center justify-center text-xs font-semibold">
                  {(m.first_name?.[0] || "") + (m.last_name?.[0] || "")}
                </div>
                <div className="min-w-0 flex-1">
                  <div className="font-display text-sm font-semibold text-slate-900 truncate">{m.first_name} {m.last_name}</div>
                  <div className="text-xs text-slate-500 truncate">{m.designation}</div>
                </div>
              </div>
              <div className="mt-3 flex items-center justify-between text-[11px] text-slate-500">
                <span>{m.department}</span>
                <span className="font-mono">{m.employee_id}</span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
